import { initSwiper } from "./modules/common/init-swiper";
import { initDrops } from "./modules/common/drop";
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';
import { initWidgetBookingModals } from "./modules/widget/modals-booking-init";
import { initMessages } from "./modules/common/message";
import IframeHeightResizer from "./modules/embed/IframeHeightResizer";

//Main Logic for loading all modals and initing booking setup
initWidgetBookingModals();

const widgetWrapper = document.getElementById('widgetWrapper');
if (widgetWrapper && widgetWrapper.hasAttribute('data-enable-auto-height-resize')) {
  const autoHeightResize = widgetWrapper.dataset.enableAutoHeightResize === 'true';
  if (autoHeightResize) {
    // Initialize iframe height resizer for dynamic height adjustment
    new IframeHeightResizer();

    // Hide experiences container when modals are open to adjust iframe height correctly
    // Optimized version: single observer, debounced, cached state
    (function() {
      const experiencesContainer = document.getElementById('experiences-container');
      if (!experiencesContainer) return;

      const body = document.body;
      const html = document.documentElement;

      // Cache state to avoid redundant DOM operations
      let isCurrentlyHidden = false;
      let debounceTimeout = null;
      let rafId = null;

      // Pre-create events once (avoid creating new Event objects on each call)
      const modalOpenedEvent = new Event('modal-opened');
      const modalClosedEvent = new Event('modal-closed');

      function isModalOpen() {
        // Check body class first (fastest)
        if (body.classList.contains('modal-active')) return true;
        // Fallback: use querySelector (stops at first match, faster than querySelectorAll)
        return document.querySelector('.modal.active') !== null;
      }

      function applyVisibilityChange(shouldHide) {
        // Skip if no change needed
        if (shouldHide === isCurrentlyHidden) return;

        isCurrentlyHidden = shouldHide;

        if (shouldHide) {
          experiencesContainer.classList.add('hidden');
          html.style.minHeight = '875px';
          body.style.minHeight = '875px';
          document.dispatchEvent(modalOpenedEvent);
        } else {
          experiencesContainer.classList.remove('hidden');
          html.style.minHeight = '';
          body.style.minHeight = '';
          document.dispatchEvent(modalClosedEvent);
        }
      }

      function scheduleVisibilityUpdate() {
        // Debounce: clear any pending update
        if (debounceTimeout) {
          clearTimeout(debounceTimeout);
        }

        debounceTimeout = setTimeout(function() {
          debounceTimeout = null;

          // Cancel any pending RAF
          if (rafId) {
            cancelAnimationFrame(rafId);
          }

          // Use RAF to batch with browser paint cycle
          rafId = requestAnimationFrame(function() {
            rafId = null;
            applyVisibilityChange(isModalOpen());
          });
        }, 50); // 50ms debounce
      }

      // Single MutationObserver on body only (catches modal-active class)
      if (window.MutationObserver) {
        const observer = new MutationObserver(scheduleVisibilityUpdate);

        observer.observe(body, {
          attributes: true,
          attributeFilter: ['class']
        });

        // Observe modal container for modal class changes (not each modal individually)
        // Use a single observer with childList to detect when modals become active
        const modalContainer = document.querySelector('.modal') ? document.querySelector('.modal').parentElement : null;
        if (modalContainer && modalContainer !== body) {
          observer.observe(modalContainer, {
            attributes: true,
            attributeFilter: ['class'],
            subtree: true
          });
        }
      }

      // Initial check (immediate, no debounce needed)
      applyVisibilityChange(isModalOpen());
    })();
  }
}

tippy('[data-tippy-content]', {
  theme: 'light'
});

initSwiper();
initDrops();

//For rating view
const handleRatings = () => {
  const rating = document.querySelector('.rating');
  if(rating){
    const stars = rating.querySelectorAll('.star');
    const input = rating.querySelector("input[type='hidden']");
    if(stars){
      stars.forEach(function(star){
        star.addEventListener('click', () => handleStars(star, stars, rating, true, input));
        star.addEventListener('mouseover', () => handleStars(star, stars, rating, false));
        star.addEventListener('mouseout', () => onStarMouseLeft(rating, stars));
      });
    }
  }
}

const handleStars = (star, stars, rating, click, input = null) => {
  const note = star.dataset.note;
  stars.forEach(function(eachStar){
    if(eachStar.dataset.note <= note){
      eachStar.classList.add('active');
    } else{
      eachStar.classList.remove('active');
    }
  });

  if(click){
    rating.dataset.initialNote = note;
    if(input) input.value = note;
  }
}

const onStarMouseLeft = (rating, stars) => {
  const initialNote = rating.dataset.initialNote;
  const initialStar = rating.querySelector(".star[data-note='"+ initialNote +"']");
  if(initialStar){
    stars.forEach(function(eachStar){
      if(eachStar.dataset.note <= initialNote){
        eachStar.classList.add('active');
      } else{
        eachStar.classList.remove('active');
      }
    });
  }
  else {
    stars.forEach(function(star){
      star.classList.remove('active');
    });
  }
}

handleRatings();

//Flash messages
initMessages();
